import React from 'react'
import { FaqCtaLabel } from '@/interfaces/common/prismicPage'
import CMSText from './CMSText'

type TProps = {
  data: FaqCtaLabel[]
}

export const isPrismicImage = (field: FaqCtaLabel) => {
  return field.type === 'image'
}

const CMSTextOrImage = ({ data }: TProps) => {
  return (
    <>
      {data.map((label, index) => {
        if (isPrismicImage(label)) {
          return <img key={index} src={label.url} alt={label.alt} />
        }
        return <CMSText key={index} data={[label]} />
      })}
    </>
  )
}

export default CMSTextOrImage
